var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationMono = function SvgLocationMono(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 16 1.4 9.1C.7 8.1.3 6.9.3 5.7.3 2.5 2.8 0 6 0s5.7 2.5 5.7 5.8c0 1.3-.4 2.4-1.1 3.3zM6 3.4c-1.3 0-2.3 1-2.3 2.3S4.7 8 6 8s2.3-1 2.3-2.3-1-2.3-2.3-2.3"
  })));
};
export default SvgLocationMono;